import { Box, Button, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

function NoAccess() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "70vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
      }}
    >
      <Stack spacing={2} alignItems="center" textAlign="center">
        <Typography variant="h2" fontWeight={700}>
          403
        </Typography>
        <Typography variant="h6">Access denied</Typography>
        <Typography color="text.secondary">
          You do not have permission to view this page.
        </Typography>
        <Stack direction="row" spacing={1}>
          <Button variant="outlined" onClick={() => navigate(-1)}>
            Go Back
          </Button>
          <Button variant="contained" onClick={() => navigate("/")}>
            Go Home
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}

export default NoAccess;
